<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="140px">
      <el-form-item label="设备类型：" prop="series">
        <Select
          style="width: 240px;"
          placeholder="设备类型"
          v-model="form.series"
          :options="form.seriesList"
        >
        </Select>
      </el-form-item>
      <el-form-item label="设备型号：" prop="model">
        <el-input v-model.trim="form.model" clearable placeholder="请填写设备型号"></el-input>
      </el-form-item>
      <el-form-item label="温区：" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio label="001u2qrwzlzysvkd">单温区</el-radio>
          <el-radio label="002u2qrwzlzysvkd">双温区</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="图片：">
        <p>格式图片：PNG、JPG、JPEG</p>
        <Upload :img="form.picture" @pickImg="(file) => pickImg(file)" />
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model.trim="form.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请填写备注"
          resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
import Upload from '@manage/components/Upload'
import { uploadFile } from '@manage/utils/utils'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object
    }
  },
  components: {
    Select,
    Upload
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        id: '',
        devType: '01', // 01厨冷 02红酒
        series: '',
        seriesList: [],
        model: '',
        type: '001u2qrwzlzysvkd',
        picture: '',
        remark: ''
      },
      rules: {
        series: [
          {
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }
        ],
        model: [
          {
            required: true,
            message: '请填写设备型号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\u4e00-\u9fa5\x21-\x7E]+$/
              if (!reg.test(value)) {
                callback(new Error('设备型号由中英文字符、数字和特殊符号组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        type: [
          {
            required: true,
            message: '请选择温区',
            trigger: 'change'
          }
        ]
      },
      addApi: this.$api.basicdata.device_type_add,
      updateApi: this.$api.basicdata.device_type_update
    }
  },
  mounted() {
    this.form.seriesList = [
      {
        code: '冰箱',
        name: '冰箱'
      },
      {
        code: '平调',
        name: '平调'
      },
      {
        code: '陈列柜',
        name: '陈列柜'
      }
    ]
    if (this.row.id) {
      this.queryDetail(this.row.id)
    }
  },
  methods: {
    queryDetail(id) {
      let params = {
        id: id
      }
      this.$ajax.get(this.$api.basicdata.device_type_detail, params).then((res) => {
        this.form = res.data
      })
    },
    pickImg(file) {
      if (file) {
        uploadFile(file).then((res) => {
          this.form.picture = res.data
        })
      } else {
        this.form.picture = ''
      }
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            devType: this.form.devType,
            series: this.form.series,
            model: this.form.model,
            type: this.form.type,
            picture: this.form.picture,
            remark: this.form.remark
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
